import "./App.css";
import AdminLogin from "./Components/AdminLogin";
import DashboardLayout from "./Pages/DashboardLayout";
import { Route, Routes } from "react-router";
import ProtectedRoute from "./routes/ProtectedRouter";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { checkAuth } from "./store/authSlice";
import { ROUTES } from "./routes/routePaths";
import DataTable from "./Components/Table";
import FacultyManagement from "./Components/FacultyManagement";
import { sampleStudentsData } from "./constant/data";
import CourseContentManagement from "./Components/Course_ContentManagement";
import OfferManagement from "./Components/OfferManagement";
import FeesManagement from "./Components/FeesManagement";
import StudentMangement from "./Components/StudentMangement";
import SubscriptionManagement from "./Components/SubscriptionManagement";
import CourseManagementPage from "./Pages/courses/CourseManagementPage";
import BatchManagementPage from "./Pages/BatchManagementPage";
import AttendanceManagementPage from "./Pages/AttendanceManagementPage";
import AllStudentsPage from "./Pages/AllStudentsPage";
import ExternalAdmissionsPage from "./Pages/ExternalAdmissionsPage";
import EnrollmentManagementPage from "./Pages/EnrollmentManagementPage";
import LectureManagementPage from "./Pages/LectureManagementPage";
import WebinarManagementPage from "./Pages/WebinarManagementPage";
import WebinarRegistrationsPage from "./Pages/WebinarRegistrationsPage";
import MainDashboardPage from "./Pages/MainDashboardPage";
import ReviewManagementPage from "./Pages/ReviewManagementPage";
import BlogManagementPage from "./Pages/BlogManagementPage";
import DemoVideoManagementPage from "./Pages/DemoVideoManagementPage";
import PlacementManagementPage from "./Pages/PlacementManagementPage";
import PrebookingPaymentPage from "./Pages/PrebookingPaymentPage";
import VideoReviewManagementPage from "./Pages/VideoReviewManagementPage";
import EnquiryManagementPage from "./Pages/EnquiryManagementPage";
import JobManagementPage from "./Pages/JobManagementPage";
import HireFromUsPage from "./Pages/HireFromUsPage";
import FaqManagementPage from "./Pages/FaqManagementPage";
import ChatbotQueriesPage from "./Pages/ChatbotQueriesPage";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <div className="App">
      <Routes>
        <Route path={ROUTES.LOGIN} element={<AdminLogin />} />
        <Route
          path={ROUTES.ROOT}
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
        <Route index element={<MainDashboardPage/>} />
          <Route
            path={ROUTES.DASHBOARD_TABLE}
            element={<DataTable data={sampleStudentsData} />}
          />
          <Route
            path={ROUTES.DASHBOARD_FACULTY_MANAGEMENT}
            element={<FacultyManagement />}
          />
          <Route path={ROUTES.DASHBOARD_LOGIN_FORM} element={<AdminLogin />} />
          <Route
            path={ROUTES.DASHBOARD_COURSE_MANAGEMENT}
            element={<CourseManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_BATCH_MANAGEMENT}
            element={<BatchManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_ATTENDANCE_MANAGEMENT}
            element={<AttendanceManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_ALL_STUDENTS}
            element={<AllStudentsPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_EXTERNAL_ADMISSIONS}
            element={<ExternalAdmissionsPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_ENROLLMENT_MANAGEMENT}
            element={<EnrollmentManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_FEES_MANAGEMENT}
            element={<FeesManagement />}
          />
          <Route
            path={ROUTES.DASHBOARD_OFFER_MANAGEMENT}
            element={<OfferManagement />}
          />
          <Route
            path={ROUTES.DASHBOARD_COURSE_CONTENT_MANAGEMENT}
            element={<CourseContentManagement />}
          />
          <Route
            path={ROUTES.DASHBOARD_STUDENT_MANAGEMENT}
            element={<StudentMangement />}
          />
          <Route
            path={ROUTES.DASHBOARD_SUBSCRIPTION_MANAGEMENT}
            element={<SubscriptionManagement />}
          />
          <Route
            path={ROUTES.DASHBOARD_WEBINAR_MANAGEMENT}
            element={<WebinarManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_WEBINAR_REGISTRATIONS}
            element={<WebinarRegistrationsPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_LECTURE_MANAGEMENT}
            element={<LectureManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_REVIEWS_MANAGEMENT}
            element={<ReviewManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_BLOG_MANAGEMENT}
            element={<BlogManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_DEMO_VIDEO_MANAGEMENT}
            element={<DemoVideoManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_PLACEMENT_MANAGEMENT}
            element={<PlacementManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_PREBOOKING_PAYMENT}
            element={<PrebookingPaymentPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_VIDEO_REVIEW_MANAGEMENT}
            element={<VideoReviewManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_ENQUIRY_MANAGEMENT}
            element={<EnquiryManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_JOB_MANAGEMENT}
            element={<JobManagementPage />}
          />
          <Route path={ROUTES.DASHBOARD_HIRE_FROM_US} element={<HireFromUsPage/>}/>
          <Route
            path={ROUTES.DASHBOARD_FAQ_MANAGEMENT}
            element={<FaqManagementPage />}
          />
          <Route
            path={ROUTES.DASHBOARD_CHATBOT_QUERIES}
            element={<ChatbotQueriesPage />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;